export default "__VITE_ASSET__u4IH0dUZ__"